var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.868,
    height: 14.868,
    viewBox: "0 0 14.868 14.868",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert",
    transform: "translate(-54.391 -406.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "error_FILL1_wght400_GRAD0_opsz48",
    d: "M11.434,15.151A.6.6,0,1,0,11,14.974.593.593,0,0,0,11.434,15.151Zm-.5-2.843h1.115v-4.7H10.932Zm.5,6.56a7.193,7.193,0,0,1-2.881-.585,7.49,7.49,0,0,1-3.968-3.968,7.426,7.426,0,0,1,0-5.78,7.429,7.429,0,0,1,1.6-2.36,7.62,7.62,0,0,1,2.37-1.589,7.426,7.426,0,0,1,5.78,0,7.422,7.422,0,0,1,3.949,3.949,7.426,7.426,0,0,1,0,5.78,7.62,7.62,0,0,1-1.589,2.37,7.429,7.429,0,0,1-2.36,1.6A7.239,7.239,0,0,1,11.434,18.868Z",
    transform: "translate(50.391 402.305)",
    fill: "#daa310"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.16a95200256ab59bf9286173bf53e62b.svg";
export { ForwardRef as ReactComponent };